var _path, _path2, _rect, _g, _rect2, _rect3, _g2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 246,
    viewBox: "0 0 405 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35938 16.5044C4.35938 9.41074 10.3829 3.66016 17.8133 3.66016H387.123C394.553 3.66016 400.577 9.41074 400.577 16.5044V229.72C400.577 236.813 394.553 242.564 387.123 242.564H17.8133C10.3829 242.564 4.35938 236.813 4.35938 229.72V16.5044Z",
    fill: "#E8EFFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8133 12.8938H387.123C389.319 12.8938 390.977 14.5763 390.977 16.5044V229.72C390.977 231.648 389.319 233.33 387.123 233.33H17.8133C15.617 233.33 13.9588 231.648 13.9588 229.72V16.5044C13.9588 14.5763 15.617 12.8938 17.8133 12.8938ZM17.8133 2.13306C9.607 2.13306 2.83228 8.50139 2.83228 16.5044V229.72C2.83228 237.723 9.60701 244.091 17.8133 244.091H387.123C395.329 244.091 402.104 237.723 402.104 229.72V16.5044C402.104 8.50139 395.329 2.13306 387.123 2.13306H17.8133Z",
    fill: "white",
    stroke: "#E8EFFB",
    strokeWidth: 3.0542
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 332.633,
    y: 19.7168,
    width: 48.434,
    height: 17.982,
    rx: 3.18831,
    fill: "#171C60"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7836_50292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.8633,
    y: 19.7168,
    width: 48.434,
    height: 17.982,
    fill: "#171C60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 19.7168,
    width: 14.7993,
    height: 17.982,
    fill: "#FF5326"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.0078,
    y: 19.7168,
    width: 17.4901,
    height: 17.982,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7891,
    y: 19.7168,
    width: 214.59,
    height: 17.982,
    rx: 3.18831,
    fill: "#A3BBDC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 89.7891,
    y: 40.9082,
    width: 214.59,
    height: 6.42214,
    rx: 3.18831,
    fill: "#A3BBDC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 160.258,
    y: 124.818,
    width: 125.141,
    height: 15.9416,
    rx: 3.18831,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 159.461,
    y: 145.543,
    width: 125.141,
    height: 15.1445,
    rx: 3.18831,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 160.258,
    y: 165.469,
    width: 124.344,
    height: 15.9416,
    rx: 3.18831,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 160.258,
    y: 186.193,
    width: 124.344,
    height: 15.1445,
    rx: 3.18831,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 294.965,
    y: 186.262,
    width: 78.7053,
    height: 15.4131,
    rx: 3.18831,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 160.258,
    y: 64.2402,
    width: 74.9253,
    height: 15.1445,
    rx: 3.18831,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 159.461,
    y: 96.123,
    width: 125.141,
    height: 15.9416,
    rx: 3.18831,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 295.363,
    y: 208.146,
    width: 68.6149,
    height: 8.991,
    rx: 3.18831,
    fill: "#A3BBDC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7842 193.336L82.7773 193.341C82.3994 193.619 82.0273 193.893 81.6618 194.162C81.2962 193.893 80.9241 193.619 80.5462 193.341L80.5393 193.336C77.9587 191.437 75.0974 189.331 72.0709 186.963C78.1836 183.254 84.5515 178.766 90.7159 173.214L91.5636 172.451C97.2262 167.429 102.944 161.501 108.071 154.256C117.562 140.843 125.253 122.493 125.12 96.5992L125.113 95.3821L123.935 95.0766C108.757 91.1402 90.6108 89.5487 81.7084 89.286L81.6618 89.2846L81.6151 89.286C72.7127 89.5487 54.5667 91.1402 39.3882 95.0766L38.2101 95.3821L38.2039 96.5992C38.071 122.493 45.7611 140.843 55.2526 154.256C59.2707 159.935 63.6524 164.804 68.0861 169.063C64.8452 171.282 61.6023 173.247 58.4179 175.019C41.1536 157.853 24.2637 131.186 27.1724 87.561C45.3951 81.0721 70.8796 78.87 81.6459 78.5864L81.6618 78.5859L81.6772 78.5863C92.4436 78.87 117.928 81.0721 136.151 87.561C138.387 121.096 128.924 144.582 116.63 161.428C108.047 173.188 98.0517 181.757 89.5725 188.265C87.164 190.113 84.882 191.792 82.7842 193.336Z",
    fill: "#1956A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5156 143.521C61.5156 133.022 70.027 124.511 80.5264 124.511C91.0257 124.511 99.5372 133.022 99.5372 143.521V145.042H61.5156V143.521Z",
    fill: "#1956A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0979 111.46C90.0979 116.85 85.7286 121.219 80.3388 121.219C74.949 121.219 70.5796 116.85 70.5796 111.46C70.5796 106.07 74.949 101.701 80.3388 101.701C85.7286 101.701 90.0979 106.07 90.0979 111.46Z",
    fill: "#1956A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7836_50292"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.8633,
    y: 19.7168,
    width: 48.4342,
    height: 17.982,
    rx: 3.18831,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideImage);
export default __webpack_public_path__ + "static/media/sideImage.b987d64f0f7ebc8686d481390f5e36e6.svg";
export { ForwardRef as ReactComponent };